import { PartnerSocketRepository } from "../repositories/PartnerSocketRepository";

export class DisconnectPartnerSocket {
	constructor(private repository: PartnerSocketRepository) {}
	execute(): Promise<void> {
		return this.repository.disconnectPartnerSocket();
	}
}
